// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getProgressionAnalysisById } from "../../api";
import { ProgressionAnalysisType } from "../../types";

export const useProgressionAnalysisById = (
  clinicId: string | undefined,
  payload: { patientId: string; analysisId: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<ProgressionAnalysisType>({
    queryKey: ["progression-analyses", payload.analysisId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return getProgressionAnalysisById(
        token,
        clinicId,
        payload.patientId,
        payload.analysisId
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the reports page
  });
};
